<template>
  <div>
    <b-card-code
      title=""
      no-body
    >
      <!-- IMPORT DEVICE -->
      <b-modal
        id="modal-select2"
        v-model="modalImport"
        title="Import Devices"
        cancel-variant="outline-secondary"
        hide-footer
        :no-close-on-backdrop="true"
        @ok=""
        @cancel="() => {
          modalImport = false
        }"
      >
        <validation-observer ref="importRules">
          <b-form @submit.prevent>
            <b-row>
              <!-- Device -->
              <b-col cols="12">
                <b-form-group
                  label="Device file"
                  label-for="import-file"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="import-file"
                    rules="required"
                  >
                    <b-media-body class="mt-75 ml-75">
                      <!-- upload button -->
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        size="sm"
                        class="mb-75 mr-75"
                        @click="$refs.refInputImportFile.$el.click()"
                      >
                        Upload
                      </b-button>
                      <b-form-file
                        id="import-file"
                        ref="refInputImportFile"
                        v-model="importFile.excelFile"
                        accept=".xls,.xlsx,.csv,.xlsm,.xltx"
                        :hidden="true"
                        plain
                        @change="uploadExcel"
                      />
                      <!--/ upload button -->

                      <!-- reset -->
                      <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        size="sm"
                        class="mb-75 mr-75"
                        @click="resetImport"
                      >
                        Reset
                      </b-button>
                      <!--/ reset -->
                      <b-card-text v-if="importFile.excelFile !== null">
                        {{ importFile.excelFile.name }}
                      </b-card-text>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-media-body>
                    <div>
                      <p>Download Example Excel File
                        <a
                          href="/Example_Import_Device_Data.xlsx"
                          download
                        >
                          Here
                        </a>
                      </p>
                    </div>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Status"
                  label-for="v-Status"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Status"
                  >
                    <v-select
                      id="v-Status"
                      v-model="importFile.device_status"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="StatusOptions"
                      :reduce="(StatusOptions) => StatusOptions.value"
                      label="title"
                      placeholder="Status"
                      class="w-100"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Update Interval"
                  label-for="v-update-interval"
                >
                  <b-form-input
                    id="v-update-interval"
                    v-model="importFile.update_interval"
                    placeholder="Update Interval"
                    type="number"
                  />
                </b-form-group>
              </b-col>

              <!-- Default Unit Input -->
              <b-col cols="12">
                <b-form-group
                  label="Default Unit"
                  label-for="v-default-unit"
                >
                  <b-form-input
                    id="v-default-unit"
                    v-model="importFile.default_unit"
                    placeholder="Default Unit"
                  />
                </b-form-group>
              </b-col>

              <!-- Installation Status Input -->
              <b-col cols="12">
                <b-form-group
                  label="Installation Status"
                  label-for="v-installation-status"
                >
                  <b-form-input
                    id="v-installation-status"
                    v-model="importFile.installation_status"
                    placeholder="Installation Status"
                  />
                </b-form-group>
              </b-col>

              <!-- Rest API Connection ID Input -->
              <b-col cols="12">
                <b-form-group
                  label="Rest API Connection ID"
                  label-for="v-restapi-connection-id"
                >
                  <b-form-input
                    id="v-restapi-connection-id"
                    v-model="importFile.restapi_connection_id"
                    placeholder="Rest API Connection ID"
                    type="number"
                  />
                </b-form-group>
              </b-col>

              <!-- Temperature and Battery Limits -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  label="Temperature Min"
                  label-for="v-temperature-limit-min"
                >
                  <b-form-input
                    id="v-temperature-limit-min"
                    v-model="importFile.temperature_limit_min"
                    placeholder="Temperature Min"
                    type="number"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  label="Temperature Med"
                  label-for="v-temperature-limit-med"
                >
                  <b-form-input
                    id="v-temperature-limit-med"
                    v-model="importFile.temperature_limit_med"
                    placeholder="Temperature Med"
                    type="number"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  label="Temperature Max"
                  label-for="v-temperature-limit-max"
                >
                  <b-form-input
                    id="v-temperature-limit-max"
                    v-model="importFile.temperature_limit_max"
                    placeholder="Temperature Max"
                    type="number"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  label="Battery Min"
                  label-for="v-battery-limit-min"
                >
                  <b-form-input
                    id="v-battery-limit-min"
                    v-model="importFile.battery_limit_min"
                    placeholder="Battery Min"
                    type="number"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  label="Battery Med"
                  label-for="v-battery-limit-med"
                >
                  <b-form-input
                    id="v-battery-limit-med"
                    v-model="importFile.battery_limit_med"
                    placeholder="Battery Med"
                    type="number"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  label="Battery Max"
                  label-for="v-battery-limit-max"
                >
                  <b-form-input
                    id="v-battery-limit-max"
                    v-model="importFile.battery_limit_max"
                    placeholder="Battery Max"
                    type="number"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <b-form-group
                  label="Service Status"
                  label-for="v-battery-limit-max"
                >
                  <v-select
                    v-model="importFile.service_status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="ServiceStatusOptions"
                    :reduce="(ServiceStatusOptions) => ServiceStatusOptions.value"
                    label="title"
                    placeholder="Service Status"
                    class="w-100"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  label="Service Start Date"
                  label-for="v-battery-limit-max"
                >
                  <flat-pickr
                    id="v-ServiceStartDate"
                    v-model="importFile.service_start_date"
                    class="form-control"
                    :config="{ enableTime: false, time_24hr: false, enableClear: true, }"
                    placeholder="DD-MM-YYYY"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  label="Service End Date"
                  label-for="v-battery-limit-max"
                >
                  <flat-pickr
                    id="v-ServiceEndDate"
                    v-model="importFile.service_end_date"
                    class="form-control"
                    :config="{ enableTime: false, time_24hr: false, enableClear: true, }"
                    placeholder="DD-MM-YYYY"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
              >
                <p>Successfully imported <span style="color: green;"> {{ importFile.response.success.length || 0 }} </span> devices</p>
                <p>Error imported <span style="color: red;"> {{ importFile.response.errors.length || 0 }} </span> devices</p>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="this.isLoading"
                  @click.prevent="importDevice"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>

      <!-- REBOOT DEVICE -->
      <b-modal
        id="modal-select2"
        v-model="modalReboot"
        title="Reboot Device"
        cancel-variant="outline-secondary"
        :no-close-on-backdrop="true"
        hide-footer
        @cancel="() => {
          modalReboot = false
          registerAsset = {
            device: [],
            status: null
          }
          rebootedResponse = {
            total: 0,
            successful: 0,
            failed: 0,
          }
        }"
      >
        <b-col
          cols="12"
          class="mt-2 mb-1"
        >
          <div
            v-if="registerAsset.device.length > 0"
          >
            <div
              v-for="(device, i) in registerAsset.device"
              :key="i"
              style="display: flex; align-items: start; column-gap: 0.5rem;"
            >
              <p style="font-weight: bold;">
                {{ device.name }}
              </p> - <p>{{ device.code }}</p> - <p style="font-weight: bold;">
                {{ device.serial_number }}
              </p>
            </div>
            <h5 class="mt-1 mb-1">
              Are you sure want to reboot ?
            </h5>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              :disabled="this.isLoading || registerAsset.device.length === 0"
              @click.prevent="rebootDevice"
            >
              Yes
            </b-button>
            <p class="mt-1">
              Result: Success: {{ this.rebootedResponse.successful }} | Failed: {{ this.rebootedResponse.failed }}
            </p>
          </div>

          <div v-if="registerAsset.device.length === 0">
            <p style="font-weight: bold;">
              Device is empty. please check the device
            </p>
          </div>
        </b-col>
      </b-modal>

      <!-- UPDATE DEVICE STATUS -->
      <b-modal
        id="modal-select2"
        v-model="modalShow"
        title="Update Device Status"
        cancel-variant="outline-secondary"
        :no-close-on-backdrop="true"
        hide-footer
        @cancel="() => {
          modalShow = false
          registerAsset = {
            device: [],
            status: null
          }
        }"
      >
        <validation-observer ref="simpleRules">
          <b-form @submit.prevent>
            <b-row>
              <!-- Device -->
              <b-col
                cols="12"
                class="mt-1"
              >
                <h5>Device List</h5>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <div
                  v-for="(device, i) in registerAsset.device"
                  v-if="registerAsset.device.length > 0"
                  :key="i"
                  style="display: flex; align-items: start; column-gap: 0.5rem;"
                >
                  <p style="font-weight: bold;">
                    {{ device.name }}
                  </p> - <p>{{ device.code }}</p> - <p style="font-weight: bold;">
                    {{ device.serial_number }}
                  </p>
                </div>
                <div v-if="registerAsset.device.length === 0">
                  <p style="font-weight: bold;">
                    Device is empty. please check the device
                  </p>
                </div>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Status"
                  label-for="v-Status"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Status"
                    rules="required"
                  >
                    <v-select
                      id="v-Status"
                      v-model="registerAsset.status"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="StatusOptions"
                      :reduce="(StatusOptions) => StatusOptions.value"
                      label="title"
                      placeholder="Status"
                      class="w-100"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="this.isLoading || registerAsset.device.length === 0"
                  @click.prevent="updateDevice"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>

      <!-- CHANGE DEVICE LOCATION -->
      <b-modal
        id="modal-select2"
        v-model="modalChange"
        title="Change Device Location"
        cancel-variant="outline-secondary"
        :no-close-on-backdrop="true"
        hide-footer
        @cancel="() => {
          modalChange = false
        }"
      >
        <validation-observer ref="deviceLocationRules">
          <b-form @submit.prevent>
            <b-row>
              <!-- Device -->
              <b-col cols="12">
                <b-form-group
                  label="Device"
                  label-for="v-Devices"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Devices"
                  >
                    <v-select
                      id="v-Devices"
                      v-model="updateSite.device"
                      label="code"
                      :clearable="false"
                      placeholder="Devices"
                      class="w-100"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12 mt-1">
                <h6>Change Location to</h6>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Province"
                  label-for="v-Province"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Province"
                    rules="required"
                  >
                    <v-select
                      id="v-Province"
                      v-model="updateSite.province"
                      :options="province"
                      :reduce="province => province.value"
                      label="title"
                      placeholder="Province"
                      class="w-100"
                      @input="onProvinceChange"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Regency"
                  label-for="v-Regency"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Regency"
                    rules="required"
                  >
                    <v-select
                      id="v-Regency"
                      v-model="updateSite.regency"
                      :options="regency"
                      :reduce="regency => regency.value"
                      label="title"
                      placeholder="Regency"
                      class="w-100"
                      @input="onRegencyChange"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="District"
                  label-for="v-District"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="District"
                  >
                    <v-select
                      id="v-District"
                      v-model="updateSite.district"
                      :options="district"
                      :reduce="district => district.value"
                      label="title"
                      placeholder="District"
                      class="w-100"
                      @input="onDistrictChange"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Site"
                  label-for="v-Site"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Site"
                  >
                    <v-select
                      id="v-Site"
                      v-model="updateSite.site"
                      :options="sites"
                      :reduce="sites => sites.value"
                      label="title"
                      placeholder="Site"
                      class="w-100"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="this.isLoading"
                  @click.prevent="updateLocationDevice"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>

      <!-- REGISTER ASSETS -->
      <b-modal
        id="modal-select2"
        v-model="modalRegister"
        title="Register Assets"
        cancel-variant="outline-secondary"
        hide-footer
        :no-close-on-backdrop="true"
        size="lg"
        @cancel="() => {
          this.modalRegister = false
        }"
      >
        <validation-observer ref="registerAssetRules">
          <b-form @submit.prevent>
            <b-row>
              <b-col
                cols="12"
                class="mt-1"
              >
                <h5>Device List</h5>
              </b-col>
              <b-col
                cols="12"
                class="mt-1"
              >
                <div
                  v-for="(device, i) in registerAsset.device"
                  v-if="registerAsset.device.length > 0"
                  :key="i"
                  style="display: flex; align-items: start; column-gap: 0.5rem;"
                >
                  <p>{{ device.code }}</p>  - <p style="font-weight: bold;">
                    {{ device.serial_number }}
                  </p> - <p
                    v-if="device.isExist"
                    style="color: green;"
                  >
                    Already Registered
                  </p> <p
                    v-else
                    style="color: red;"
                  >
                    Not Registered
                  </p>
                  <p style="font-weight: bold;">
                    {{ getNestedProperty(device, 'locations.areas.sites.name') }}
                  </p>
                  <p style="font-weight: bold;">
                    - {{ getNestedProperty(device, 'locations.areas.sites.code') }}
                  </p>
                </div>
                <div v-if="registerAsset.device.length === 0">
                  <p style="font-weight: bold;">
                    Device is empty. please check the device
                  </p>
                </div>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="this.isLoading || registerAsset.device.length === 0"
                  @click.prevent="registerAssetDevice"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>

      <!-- RECOVER DATA -->
      <b-modal
        id="modal-select2"
        v-model="modalRecover"
        title="Recover Historical Device Data"
        cancel-variant="outline-secondary"
        :no-close-on-backdrop="true"
        size="lg"
        hide-footer
        @cancel="resetSseData"
      >
        <validation-observer ref="simpleRules">
          <b-form @submit.prevent>
            <b-row>
              <!-- Device -->
              <b-col cols="12">
                <b-form-group
                  label="Device"
                  label-for="v-Devices"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Devices"
                    rules="required"
                  >
                    <v-select
                      id="v-Devices"
                      v-model="recoverData.deviceGuid"
                      :options="items"
                      label="code"
                      placeholder="Devices"
                      class="w-100"
                      multiple
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="StartDate"
                      label-for="v-StartDate"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="StartDate"
                        rules="required"
                      >
                        <b-form-datepicker
                          id="v-StartDate"
                          v-model="recoverData.startTime"
                          placeholder="StartDate"
                          class="w-100"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="EndDate"
                      label-for="v-EndDate"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="EndDate"
                        rules="required"
                      >
                        <b-form-datepicker
                          id="v-EndDate"
                          v-model="recoverData.endTime"
                          placeholder="EndDate"
                          class="w-100"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12">
                <b-progress
                  v-if="sseData.isProcessing"
                  :value="sseData.progress"
                  :max="100"
                  show-progress
                  animated
                >
                  <b-progress-bar :value="sseData.progress">
                    {{ sseData.progressMessage + ' ' + sseData.progress + '%' }}
                  </b-progress-bar>
                </b-progress>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="sseData.isProcessing"
                  @click.prevent="recoverDevice"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>

      <!-- ACTION BUTTON -->
      <div class="mr-2">
        <b-dropdown
          id="dropdown-1"
          class="sidebar-right"
          text="Action"
          variant="primary"
          right
        >
          <b-dropdown-item :to="{ path: '/project-device/add' }">
            Create Device
          </b-dropdown-item>
          <b-dropdown-item @click="() => { modalImport = true }">
            Import Device
          </b-dropdown-item>
          <b-dropdown-item :to="{ path: '/project-device/replace' }">
            Replace Device
          </b-dropdown-item>
          <b-dropdown-item @click="() => { modalRecover = true }">
            Recover Device
          </b-dropdown-item>
          <b-dropdown-item :to="{ path: '/temperature-device/installation' }">
            Installation Device
          </b-dropdown-item>
          <b-dropdown-item :to="{ path: '/data/export-historical-device' }">
            Export Historical
          </b-dropdown-item>
        </b-dropdown>
        <b-dropdown
          v-if="registerAsset.device.length > 0"
          id="dropdown-2"
          class="sidebar-right mr-2"
          :text="`${registerAsset.device.length} Device Selected`"
          variant="secondary"
          right
        >
          <b-dropdown-item @click="() => { modalShow = true }">
            Update Status
          </b-dropdown-item>
          <b-dropdown-item @click="() => { modalRegister = true }">
            Register Assets
          </b-dropdown-item>
          <b-dropdown-item @click="() => { modalReboot = true }">
            Reboot Device
          </b-dropdown-item>
        </b-dropdown>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="sidebar-right mr-2"
          variant="outline-primary"
          @click="resetFilter"
        >
          <feather-icon icon="SearchIcon" /> Reset Filter
        </b-button>
      </div>

      <!-- FILTER DEVICE -->
      <div class="mx-2 mt-2">
        <b-row
          xl="12"
          sm="12"
          class="mb-2"
        >
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Province"
              v-model="updateFilter.province"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="province"
              :reduce="(province) => province.value"
              label="title"
              placeholder="--Select Province --"
              class="w-100"
              @input="onProvinceChange"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Regency"
              v-model="updateFilter.regency"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="regency"
              :reduce="(regency) => regency.value"
              label="title"
              placeholder="--Select Regency --"
              class="w-100"
              @input="onRegencyChange"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-District"
              v-model="updateFilter.district"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="district"
              :reduce="(district) => district.value"
              label="title"
              placeholder="--Select District --"
              class="w-100"
              @input="onFilterDistrictChange"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Site"
              v-model="updateFilter.site"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sites"
              :reduce="(sites) => sites.value"
              label="title"
              placeholder="--Select Site --"
              class="w-100"
              @input="onSiteChange"
            />
          </b-col>
        </b-row>
        <b-row
          xl="12"
          sm="12"
          class="mb-2"
        >
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Area"
              v-model="updateFilter.area"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="areas"
              :reduce="(areas) => areas.value"
              label="title"
              placeholder="--Select Area --"
              class="w-100"
              @input="onAreaChange"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Regency"
              v-model="updateFilter.location"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="locations"
              :reduce="(locations) => locations.value"
              label="title"
              placeholder="--Select Location --"
              class="w-100"
              @input="filterDevice"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              v-model="updateFilter.device_type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="DeviceTypeOptions"
              :reduce="(DeviceTypeOptions) => DeviceTypeOptions.value"
              label="title"
              placeholder="Device Type"
              class="w-100"
              @input="filterDevice"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              v-model="updateFilter.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="StatusOptions"
              :reduce="(StatusOptions) => StatusOptions.value"
              label="title"
              placeholder="Status"
              class="w-100"
              @input="filterDevice"
            />
          </b-col>
        </b-row>
      </div>

      <!-- SORT BUTTON -->
      <div class="d-flex justify-content-between flex-wrap mx-2 mb-1">
        <b-form-group>
          <b-input-group size="sm">
            <b-form-select
              v-model="sortBy"
              :options="sortOptions"
            >
              <template #first>
                <option value="">
                  none
                </option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc"
              size="sm"
              :disabled="!sortBy"
            >
              <option :value="false">
                Asc
              </option>
              <option :value="true">
                Desc
              </option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
        <!-- filter -->
        <b-form-group>
          <b-input-group size="sm">
            <b-form-input
              v-model="updateFilter.search"
              type="search"
              placeholder="Type to Search"
              @input="filterDevice"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <!-- TABLE DEVICE -->
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <b-table
          striped
          hover
          responsive
          class="position-relative"
          :items="deviceItems"
          :fields="filteredFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(is_check)="data">
            <b-form-checkbox
              :id="`checkbox${data.index}`"
              v-model="data.item.is_check"
              :name="`checkbox-${data.index}`"
              :value="true"
              :unchecked-value="false"
              @input="() => checkRegisterAsset(data.item.is_check, data.item)"
            />
          </template>
          <template #cell(created_at)="data">
            {{ dateFormat(data.value) }}
          </template>
          <template #cell(site_name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(site_code)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(province_name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(regency_name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(district_name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(iccid)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(msisdn)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(signal_type)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(logo)="data">
            <b-img
              width="50"
              :src="data.value"
            />
          </template>
          <template #cell(status)="data">
            <b-badge :variant="statusBadge[1][data.value]">
              {{ statusBadge[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(installation_status)="data">
            <b-badge :variant="installationStatusBadge[1][data.value]">
              {{ installationStatusBadge[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(value)="row">
            {{ `${row.item.value !== null ? Number(row.item.value).toFixed(2) : "0.00"}` }}
          </template>
          <template #cell(device_status_connection)="data">
            <b-badge :variant="device_status[1][data.value]">
              {{ device_status[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(last_online_device)="data">
            {{ formatRelativeTime(data.value) || '-' }}
          </template>
          <template #cell(last_get_data)="data">
            {{ formatRelativeTime(data.value) || '-' }}
          </template>
          <template #cell(last_send_data)="data">
            {{ formatRelativeTime(data.value) || '-' }}
          </template>
          <template #cell(is_offline_alarm)="row">
            <b-avatar
              v-if="row.item.is_offline_alarm === false && projectUndp !== 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_offline_alarm === true && projectUndp !== 6"
              size="sm"
              variant="danger"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_offline_alarm === false && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.status === 'ER' && projectUndp === 6"
              size="sm"
              style="color: black;"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_offline_alarm === true && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="danger"
              text=" "
            />
          </template>
          <template #cell(is_over_limit_max)="row">
            <b-avatar
              v-if="row.item.is_over_limit_max === false && projectUndp !== 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_over_limit_max === true && projectUndp !== 6"
              size="sm"
              variant="danger"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_over_limit_max === false && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.status === 'ER' && projectUndp === 6"
              size="sm"
              style="color: black;"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_over_limit_max === true && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="danger"
              text=" "
            />
          </template>
          <template #cell(is_over_limit_min)="row">
            <b-avatar
              v-if="row.item.is_over_limit_min === false && projectUndp !== 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_over_limit_min === true && projectUndp !== 6"
              size="sm"
              variant="danger"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_over_limit_min === false && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.status === 'ER' && projectUndp === 6"
              size="sm"
              style="color: black;"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_over_limit_min === true && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="danger"
              text=" "
            />
          </template>
          <template #cell(is_power_disconnect)="row">
            <b-avatar
              v-if="row.item.is_power_disconnect === false && projectUndp !== 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_disconnect === true && projectUndp !== 6"
              size="sm"
              variant="danger"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_disconnect === false && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.status === 'ER' && projectUndp === 6"
              size="sm"
              style="color: black;"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_disconnect === true && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="danger"
              text=" "
            />
          </template>
          <template #cell(is_power_low)="row">
            <b-avatar
              v-if="row.item.is_power_low === false && projectUndp !== 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_low === true && projectUndp !== 6"
              size="sm"
              variant="danger"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_low === false && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.status === 'ER' && projectUndp === 6"
              size="sm"
              style="color: black;"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_low === true && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="danger"
              text=" "
            />
          </template>
          <template #cell(is_power_shutdown)="row">
            <b-avatar
              v-if="row.item.is_power_shutdown === false && projectUndp !== 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_shutdown === true && projectUndp !== 6"
              size="sm"
              variant="danger"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_shutdown === false && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.status === 'ER' && projectUndp === 6"
              size="sm"
              style="color: black;"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_power_shutdown === true && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="danger"
              text=" "
            />
          </template>
          <template #cell(is_probe_fault)="row">
            <b-avatar
              v-if="row.item.is_probe_fault === false && projectUndp !== 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_probe_fault === true && projectUndp !== 6"
              size="sm"
              variant="danger"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_probe_fault === false && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="success"
              text=" "
            />
            <b-avatar
              v-if="row.item.status === 'ER' && projectUndp === 6"
              size="sm"
              style="color: black;"
              text=" "
            />
            <b-avatar
              v-if="row.item.is_probe_fault === true && row.item.status === 'IN' && projectUndp === 6"
              size="sm"
              variant="danger"
              text=" "
            />
          </template>
          <template #cell(serial_number)="row">
            <b-link
              :to="{ path: '/temperature-device/detail/' + row.item.id }"
            >
              <span>{{ row.item.serial_number }}</span>
            </b-link>
          </template>
          <template #cell(action)="row">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item>
                  <b-link :to="{ path: '/project-device/detail/'+ row.item.id}">
                    <feather-icon
                      icon="Edit2Icon"
                      class="mr-50"
                    />
                    <span>Edit</span>
                  </b-link>
                </b-dropdown-item>
                <b-dropdown-item>
                  <b-link
                    @click="() => {
                      modalChange=true;
                      updateSite.device = row.item
                    }"
                  >
                    <feather-icon
                      icon="Edit2Icon"
                      class="mr-50"
                    />
                    <span>Change Location</span>
                  </b-link>
                </b-dropdown-item>
                <!-- <b-dropdown-item>
              <b-link @click="debug(row.item.device_id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Register Asset</span>
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link @click="debug(row.item.device_id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Change Status</span>
              </b-link>
            </b-dropdown-item> -->
                <b-dropdown-item>
                  <b-link
                    v-b-modal.modal-center
                    @click="rowOnDelete(row.item.id)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      class="mr-50"
                    />
                    <span>Delete</span>
                  </b-link>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </template>
        </b-table>
        <p class="text-nowrap align-left">
          &nbsp;Total Rows {{ totalRows }}
        </p>
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @input="filterDevice"
          />
        </b-form-group>
        <p class="text-nowrap mb-md-0 mr-1 align-left" />
        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="filterDevice"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card-code>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar, BFormFile, BCard, BCardText, BTable, BProgress, BProgressBar, BFormDatepicker, BFormCheckbox, BRow, BCol, BImg, BBadge, BForm, BMedia, BMediaAside, BMediaBody, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, VBModal,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import axios from 'axios'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
import store from '@/store/index'

export default {
  components: {
    ValidationProvider, ValidationObserver, vSelect, flatPickr, BCardCode, BProgress, BProgressBar, BFormDatepicker, BCard, BCardText, BTable, BFormCheckbox, BRow, BFormFile, BMedia, BMediaAside, BMediaBody, BCol, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BAvatar, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent, BForm, VBModal,
  },
  data() {
    return {
      data: [
        {
          icons: require('@/assets/images/icons/site.png'),
          icon: 'UsersIcon',
          color: 'light-warning',
          title: 0,
          subtitle: 'Total',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/online.png'),
          icon: 'UserIcon',
          color: 'light-info',
          title: 0,
          subtitle: 'Online',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: 'DollarSignIcon',
          color: 'light-success',
          subtitle: 'Offline',
          title: 0,
          customClass: 'mb-3 mb-sm-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: '',
          color: 'light-info',
          title: 0,
          subtitle: 'Error',
          customClass: 'mb-3 mb-xl-0',
        },
      ],
      projectUndp: 0,
      select_device_type: null,
      select_status: null,
      dir: false,
      modalShow: false,
      modalImport: false,
      modalChange: false,
      modalRegister: false,
      modalRecover: false,
      modalReboot: false,
      currentPage: 1,
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      StatusOptions: [
        { title: 'Available', value: 'AC' },
        { title: 'Online', value: 'IN' },
        { title: 'Deleted', value: 'DL' },
        { title: 'Offline', value: 'ER' },
        { title: 'Error', value: 'FL' },
      ],
      status: [{
        AC: 'Available', IN: 'Unavailable', DL: 'Deleted', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-success', IN: 'light-danger', DL: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      ServiceStatusOptions: [
        { title: 'Active', value: 'ACTIVE' },
        { title: 'Expired', value: 'EXPIRED' },
        { title: 'Inactive', value: 'INACTIVE' },
      ],
      device_status: [
        {
          ONLINE: 'Online',
          OFFLINE: 'Offline',
        },
        {
          ONLINE: 'light-success',
          OFFLINE: 'light-warning',
        },
      ],
      statusBadge: [
        {
          FL: 'Error',
          IN: 'Online',
          ER: 'Offline',
          DL: 'Deleted',
          AC: 'Available',
        },
        {
          FL: 'light-warning',
          IN: 'light-success',
          ER: 'light-secondary',
          DL: 'light-danger',
          AC: 'light-primary',
        },
      ],
      installationStatusBadge: [
        {
          UI: 'Waiting Installation',
          IN: 'Approve',
          DF: 'Approve With Note',
          VF: 'Waiting Verif',
          RJ: 'Reject',
          CP: 'Complete',
        },
        {
          IN: 'light-warning',
          DF: 'light-success',
          VF: 'light-info',
          RJ: 'light-danger',
          CP: 'light-success',
        },
      ],
      importFile: {
        excelFile: null,
        device_status: 'AC',
        update_interval: '15',
        default_unit: '°C',
        installation_status: 'UI',
        restapi_connection_id: '3',
        temperature_default_unit: '°C',
        temperature_limit_min: '2',
        temperature_limit_med: '4',
        temperature_limit_max: '8',
        battery_default_unit: '%',
        battery_limit_min: '0',
        battery_limit_med: '50',
        battery_limit_max: '100',
        service_status: 'ACTIVE',
        service_start_date: new Date().toISOString(),
        service_end_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString(),
        response: {
          success: {
            length: 0,
          },
          errors: {
            length: 0,
          },
        },
      },
      updateFilter: {
        province: null,
        regency: null,
        district: null,
        site: null,
        area: null,
        location: null,
        device_type: null,
        status: null,
        search: null,
      },
      rebootedResponse: {
        total: 0,
        successful: 0,
        failed: 0,
      },
      updateSite: {
        device: null,
        province: null,
        regency: null,
        district: null,
        site: null,
      },
      registerAsset: {
        device: [],
        status: null,
      },
      recoverData: {
        deviceGuid: null,
        startTime: null,
        endTime: null,
      },
      sseData: {
        isProcessing: false,
        progress: 0,
        status: 'start',
        eventSource: null,
        progressMessage: '',
      },
      historicalUrl: '/internal/master/devices/historical-devices',
      isLoading: false,
      required,
    }
  },
  computed: {
    ...mapState({
      items: state => state.device.items,
      totalRows: state => state.device.totalRows,
      filteredFields: state => state.device.filteredFields,
      deviceItems: state => state.device.deviceItems,
      pageOptions: state => state.device.pageOptions,
      DeviceTypeOptions: state => state.temperature.devicetypeoptions,
      province: state => state.region.province,
      regency: state => state.region.regency,
      district: state => state.region.district,
      sites: state => state.site.options,
      areas: state => state.region.area,
      locations: state => state.region.location,
      filteredDevices: state => state.device.filteredDevices,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.filteredFields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    },
    mapFilter() {
      return {
        province_id: this.updateFilter.province,
        regency_id: this.updateFilter.regency,
        district_id: this.updateFilter.district,
        site_id: this.updateFilter.site,
        area_id: this.updateFilter.area,
        location_id: this.updateFilter.location,
        device_type_id: this.updateFilter.device_type,
        status: this.updateFilter.status,
        page: this.currentPage,
        perPage: this.perPage,
        search: this.updateFilter.search,
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.deviceItems.length
  },
  created() {
    this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
    this.$store.dispatch('device/getAll')
    this.$store.dispatch('region/province')
    this.$store.dispatch('temperature/getDeviceType')
  },
  methods: {
    debug(data) {
      console.log(data)
    },
    getNestedProperty(obj, path) {
      return path.split('.').reduce((prev, curr) => (prev ? prev[curr] : null), obj) || ''
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    resetFilter() {
      this.updateFilter = {
        province: null,
        regency: null,
        district: null,
        site: null,
        area: null,
        location: null,
        device_type: null,
        status: null,
        search: null,
      }
      this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.$store.state.totalActive = filteredItems.filter(f => f.status == 'IN').length
      this.$store.state.totalOffline = filteredItems.filter(f => f.status == 'ER').length
      this.$store.state.totalError = filteredItems.filter(f => f.status == 'FL').length
      this.currentPage = 1
      this.data[0].title = this.totalRows
      this.data[1].title = this.totalActive
      this.data[2].title = this.totalOffline
      this.data[3].title = this.totalError
    },
    checkRegisterAsset(checked, newDevice) {
      let devices = this.registerAsset.device
      if (checked) {
        devices.push(newDevice)
      } else {
        devices = devices.filter(item => item.device_id !== newDevice.device_id)
      }
      this.registerAsset = { ...this.registerAsset, device: devices }
      this.checkRegisteredDevice()
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete device.', {
          title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$store.dispatch('device/remove', id)
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
                  this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                } else {
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                }
              },
              error => {
                this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
              })
          }
        })
    },
    uploadExcel(e) {
      const excelFile = e.target.files[0]
      this.importFile.excelFile = excelFile
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    resetUpdate(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.modalShow = false
      this.registerAsset = {
        device: [],
        status: null,
      }
    },
    resetImport(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.importFile = {
        ...this.importFile,
        excelFile: null,
      }
    },
    filterDevice() {
      this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
    },
    clearDevices() {
      this.registerAsset = { ...this.registerAsset, device: [] }
    },
    onProvinceChange(selectedProvince) {
      this.$store.dispatch('region/regency', selectedProvince)
      this.$store.dispatch('site/setFilterProvince', selectedProvince)
      this.filterDevice()
    },
    onRegencyChange(selectedRegency) {
      this.$store.dispatch('region/district', selectedRegency)
      this.$store.dispatch('site/setFilterRegencyOnly', selectedRegency)
      this.filterDevice()
    },
    onDistrictChange() {
      this.$store.dispatch('site/getByFilterOnly', {
        province: this.updateSite.province,
        regency: this.updateSite.regency,
      })
    },
    onFilterDistrictChange() {
      this.$store.dispatch('site/getByFilterOnly', {
        province: this.updateFilter.province,
        regency: this.updateFilter.regency,
        district: this.updateFilter.district,
      })
      this.filterDevice()
    },
    onSiteChange(selectedSite) {
      this.$store.dispatch('region/area', selectedSite)
      this.filterDevice()
    },
    onAreaChange(selectedArea) {
      this.$store.dispatch('region/location', selectedArea)
      this.filterDevice()
    },
    renderStatusDevice(deviceStatus, installationDevice) {
      if (deviceStatus === 'IN' && installationDevice === '') {
        return 'In Progress'
      }
      return deviceStatus
    },
    formatRelativeTime(dateString) {
      if (!dateString) return null

      const date = new Date(dateString)
      const now = new Date()
      const diffInSeconds = Math.floor((now - date) / 1000)
      const diffInMinutes = Math.floor(diffInSeconds / 60)
      const diffInHours = Math.floor(diffInMinutes / 60)
      const diffInDays = Math.floor(diffInHours / 24)

      if (diffInSeconds < 60) {
        return 'just now'
      } if (diffInMinutes < 60) {
        return `${diffInMinutes} ${diffInMinutes === 1 ? 'minute' : 'minutes'} ago`
      } if (diffInHours < 24) {
        return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'} ago`
      }
      return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'} ago`
    },
    async checkRegisteredDevice() {
      try {
        // Map each device in `this.registerAsset.device` to a Promise
        const checkPromises = this.registerAsset.device.map(async device => {
          const headers = {
            authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          }
          const param = `${process.env.VUE_APP_DEVICE_API}/internal/add-on/smile/assets?page=1&paginate=10&working_status_id=&only_type_logger=1&status=1&keyword=${device.serial_number}`
          if (!device?.isGet) {
            const response = await axios.get(param, { headers })
            return { ...device, isExist: response.data.list.length > 0, isGet: true }
          }
          return device
        })

        // Wait for all Promises to resolve
        this.registerAsset.device = await Promise.all(checkPromises)
      } catch (err) {
        console.log(err)
      }
    },
    async rebootDevice(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        const postData = {
          msisdn: this.registerAsset.device.map(item => item?.provider_cards?.msisdn),
        }
        const headers = {
          authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
        const response = await axios.post(`${process.env.VUE_APP_DEVICE_API}/internal/master/devices/reboot`, postData, { headers })
        this.rebootedResponse = response.data?.data.summary
        this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
        // this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
      } catch (err) {
        console.log(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },
    async importDevice(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        const isValid = await this.$refs.importRules.validate()
        if (!isValid) {
          this.isLoading = false
          return
        }
        this.importFile.response = {
          success: {
            length: 0,
          },
          errors: {
            length: 0,
          },
        }
        const formData = new FormData()
        const projectId = +JSON.parse(localStorage.getItem('userData')).data?.project[0]?.project_id
        formData.append('excelFile', this.importFile.excelFile)
        for (const key in this.importFile) {
          if (this.importFile.hasOwnProperty(key) && key !== 'excelFile') {
            formData.append(key, this.importFile[key])
          }
        }
        formData.append('project_id', projectId)
        const response = await axios.post(`${process.env.VUE_APP_DEVICE_API}/internal/master/devices/import-devices`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        })
        this.importFile.response = response?.data?.responseObject
        this.notification('Success', 'CheckIcon', 'success', response?.data?.message)
        this.excelFile = null
        this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
      } catch (err) {
        console.log(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },
    async updateDevice(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        const isValid = await this.$refs.simpleRules.validate()
        if (!isValid) {
          this.isLoading = false
          return
        }
        const updatedData = {
          data: { status: this.registerAsset.status },
          devices_id: this.registerAsset.device.map(item => item.device_id),
        }
        const headers = {
          authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
        await axios.put(`${process.env.VUE_APP_DEVICE_API}/internal/master/devices/bulk-update`, updatedData, { headers })
        this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
        this.modalShow = false
        this.registerAsset.device = []
        this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
      } catch (err) {
        console.log(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },
    async updateLocationDevice(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        const isValid = await this.$refs.deviceLocationRules.validate()
        if (!isValid) {
          this.isLoading = false
          return
        }
        const updatedData = {
          site_id: this.updateSite.site,
        }
        const headers = {
          authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
        const device_id = this.updateSite.device?.device_id
        await axios.put(`${process.env.VUE_APP_DEVICE_API}internal/add-on/devices/${device_id}`, updatedData, { headers })
        this.notification('Success', 'CheckIcon', 'success', 'You have successfully Update Location Device')
        this.modalChange = false
        this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
      } catch (err) {
        console.log(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },
    async registerAssetDevice(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        const devicesData = this.registerAsset.device
        const promises = devicesData.map(device => {
          const postData = {
            serial_number: device.serial_number,
            prod_year: new Date(device.created_at).getFullYear().toString(),
            type_id: 7,
            lat: device.latitude || 0.0,
            lng: device.longitude || 0.0,
            model_id: device?.device_types?.model_id,
            manufacture_id: 69,
            status: 1,
            name: device.name,
            entity_id: Number(device?.locations?.areas?.sites?.code),
          }
          const headers = {
            authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          }

          return axios.post(`${process.env.VUE_APP_DEVICE_API}/internal/add-on/smile/assets`, postData, { headers })
        })

        await Promise.all(promises)
        this.notification('Success', 'CheckIcon', 'success', 'You have successfully Registered Assets')
        this.modalRegister = false
        await this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
      } catch (err) {
        console.log(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },
    async registerSingleAssetDevice(bvModalEvent, device) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        const postData = {
          serial_number: device.device_serial_number,
          prod_year: new Date(device.device_created_at).getFullYear().toString(),
          type_id: device.device_type_id,
          lat: device.latitude || 0.0,
          lng: device.longitude || 0.0,
          model_id: 1,
          manufacture_id: 69,
          status: 1,
          name: device.device_name,
          entity_id: Number(device.device_id),
        }

        const headers = {
          authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }

        axios.post(`${process.env.VUE_APP_SMILE_ROOT_API}/assets`, postData, { headers })
        this.notification('Success', 'CheckIcon', 'success', 'You have successfully Registered Assets')
        this.modalRegister = false
        await this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
      } catch (err) {
        console.log(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },
    async recoverDevice(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        const api = process.env.VUE_APP_DEVICE_API
        const isValid = await this.$refs.simpleRules.validate()
        if (!isValid) {
          this.isLoading = false
          return
        }
        this.sseData = {
          ...this.sseData,
          isProcessing: true,
          progress: 0,
          status: 'start',
          eventSource: null,
        }
        const recoveredData = {
          deviceGuid: this.recoverData.deviceGuid.map(device => device.serial_number),
          startTime: this.recoverData.startTime ? Math.floor(new Date(this.recoverData.startTime).getTime() / 1000) : null,
          endTime: this.recoverData.endTime ? Math.floor(new Date(this.recoverData.endTime).getTime() / 1000) : null,
        }
        fetch(api + this.historicalUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(recoveredData),
          credentials: 'include',
        }).then(response => {
          const reader = response.body.getReader()
          const decoder = new TextDecoder()

          const processStream = async () => {
            while (true) {
              let complete = false
              // eslint-disable-next-line no-await-in-loop
              const { done, value } = await reader.read()
              if (done || complete) break

              const chunk = decoder.decode(value, { stream: true })
              const lines = chunk.split('\n\n')
              lines.forEach(line => {
                if (line.startsWith('data: ')) {
                  const jsonData = line.slice(6)
                  try {
                    const data = JSON.parse(jsonData)
                    this.handleSSEMessage(data)
                    if (data.status === 'complete') {
                      complete = true
                    }
                  } catch (error) {
                    console.error('Error parsing SSE data:', error)
                  }
                }
              })
            }
          }

          processStream().catch(error => {
            console.error('Error processing stream:', error)
          })
        }).catch(error => {
          this.processFailed(error)
          console.error('Error initiating SSE connection:', error)
        })
      } catch (err) {
        console.log(err)
        this.processFailed(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },

    handleSSEMessage(data) {
      if (data.status === 'complete') {
        this.processCompleted(data)
      } else if (data.progress !== undefined) {
        this.updateProgress(data.progress, data.message)
      }
    },

    updateProgress(progress, message) {
      this.sseData.progress = progress
      this.sseData.progressMessage = message
    },

    processCompleted() {
      this.resetSseData()
      this.modalShow = false
      this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
      this.$store.dispatch('device/getAll', this.params)
      if (this.eventSource) {
        this.eventSource.close()
      }
    },

    processFailed(err) {
      this.notification('Failed', 'CloseIcon', 'danger', `You have unsuccessful ${err}`)
      this.$store.dispatch('device/getAll', this.params)
      if (this.eventSource) {
        this.eventSource.close()
      }
    },

    resetSseData() {
      this.sseData = {
        isProcessing: false,
        progress: 0,
        status: 'start',
        eventSource: null,
        progressMessage: '',
      }
      this.recoverData = {
        deviceGuid: null,
        startTime: null,
        endTime: null,
      }
    },
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
